module.exports = __webpack_public_path__ + "media/images/icons/flags/BZ-ab54c42aacb904bc69c207a53974d359.svg";